import React, {  useRef, useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import JoditEditor from 'jodit-react';
const BlockChainEmail = () => {

    const DisRef = useRef(null);
    const [Dis, setDisContent] = useState("");
    const [errorMessage, setErrorMessage] = useState([]);
    const [image, setImage] = useState("");

    const handleImage = (e) => {
        setImage(e.target.files[0]);
    };

    const refSubmitDis = useRef();


    const handleSubmitData = event => {
        event.preventDefault();
        refSubmitDis.current.setAttribute("disabled", true);
        setErrorMessage();
        const formData = new FormData(event.currentTarget);
        const InpuData = Object.fromEntries(formData);
        const sendData = { ...InpuData, image: image, message: Dis };

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            }
        };
        axios.post(`https://api.wlfmobile.com/api/admin/block/chain/email/send`, sendData, config)
            .then(response => {
                event.target.reset();
                toast.success(`${response?.data.message}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setImage('');
                setDisContent('');
                refSubmitDis.current.removeAttribute("disabled");
            }).catch((error) => {
                if (error?.response) {
                    setErrorMessage(error?.response?.data?.errors)
                }
                refSubmitDis.current.removeAttribute("disabled");
            });

    }




    return (
        <>
            {/* <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">Block Chain Email</h6>
                <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
                </div>
            </div> */}

            <div className="row mb-none-30 justify-content-center">
                <div className="col-xl-12 col-md-6 mb-30">
                    <div className="card b-radius--10 overflow-hidden box--shadow1">
                        <div className="card-body">
                            <h5 className="card-title mb-50 border-bottom pb-2"> Block Chain Email</h5>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <form onSubmit={handleSubmitData}>
                                        <div className="row">
                                            <div className=" col-md-12 ">
                                                <div className="form-group">
                                                    <label htmlFor="heading" className="required">To</label>
                                                    <input type="email" className="form-control" name="email" placeholder='Email' id="heading" />
                                                    {errorMessage?.email && (
                                                        <span className="text-danger pt-2">
                                                            {errorMessage?.email?.msg}
                                                        </span>
                                                    )}
                                                </div>


                                            </div>
                                            <div className=" col-md-12 ">
                                                <div className="form-group">
                                                    <label htmlFor="heading" className="required">Subject</label>
                                                    <input type="text" className="form-control" name="subject" placeholder='subject' id="heading" />
                                                    {errorMessage?.subject && (
                                                        <span className="text-danger pt-2">
                                                            {errorMessage?.subject?.msg}
                                                        </span>
                                                    )}
                                                </div>



                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="heading" className="required">Message</label>
                                                    <JoditEditor
                                                        ref={DisRef}
                                                        value={Dis}
                                                        height="600"
                                                        onChange={(newContent) => setDisContent(newContent)}
                                                    />
                                                </div>
                                                {errorMessage?.message && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.message?.msg}
                                                    </span>
                                                )}
                                            </div>


                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <div className="image-upload">
                                                        <div className="thumb">
                                                            <div className="avatar-edit">
                                                                <input
                                                                    type="file"
                                                                    onChange={handleImage}
                                                                    className="profilePicUpload"
                                                                    id="profilePicUpload0"
                                                                    accept=".jpg,.jpeg,.png"
                                                                />
                                                                <label
                                                                    htmlFor="profilePicUpload0"
                                                                    className="bg--primary"
                                                                >
                                                                    Choose Image
                                                                </label>
                                                                <small class="mt-2  ">
                                                                    Supported files: <b>jpeg, jpg, png.</b>

                                                                </small>
                                                                <br />
                                                                {/* {errorMessage?.message && (
                                                                    <span className="text-danger pt-2">
                                                                        {errorMessage?.message}
                                                                    </span>
                                                                )} */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="form-group">
                                            <button ref={refSubmitDis} type="submit" className="btn btn-primary w-100 h-45">Send</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlockChainEmail;